import { ErrorMessage, useField } from 'formik';
import { BiHide, BiShow } from 'react-icons/bi';
import styles from './TextField.module.css';

const TextFieldd = ({ label, showClick, icon, showPass = false, visibility = false, ...props }: any) => {
    const [field, meta] = useField(props);

    return (
        <div className={styles.textFieldContainer}>
            <label className={styles.label} htmlFor={field.name}>
                {label}
            </label>
            <div className={styles.passwordInput}>
                <div className={styles.iconBox}>{icon}</div>
                <input
                    className={`${styles.validationInput} ${meta.touched && meta.error && styles.isInValid}`}
                    style={{ ...props }}
                    {...field}
                    {...props}
                    autoComplete="off"
                />
                {visibility ? (
                    showPass ? (
                        <BiShow className={styles.showHide} onClick={showClick} />
                    ) : (
                        <BiHide className={styles.showHide} onClick={showClick} />
                    )
                ) : null}
            </div>
            {/* @ts-ignore */}
            <ErrorMessage component="div" name={field.name} className={styles.error} />
        </div>
    );
};

export default TextFieldd;
